import { render, staticRenderFns } from "./LoadPageComponent.vue?vue&type=template&id=2153b775&scoped=true&"
import script from "./LoadPageComponent.vue?vue&type=script&lang=js&"
export * from "./LoadPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoadPageComponent.vue?vue&type=style&index=0&id=2153b775&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153b775",
  null
  
)

export default component.exports